import React from 'react';
import BreadcrumbDemo from './app-breadcrumbs';
import UserMenu from './user-menu';
import { useAuthContext } from '@context/useAuthStore';
import { SidebarTrigger } from '@/components/ui/sidebar';

import CreditCoinSvg from '@/assets/svg/credit_coin.svg';
import FireSvg from '@/assets/svg/fire.svg';

const AppTopbar = () => {
  const { subscription } = useAuthContext();

  const RemainingTokens = subscription?.active_plan?.daily_token - subscription?.usageDetails?.currentUsage;

  return (
    <header className="w-full sticky top-0 flex justify-between items-center py-1 px-2 bg-sidebar z-50 border-b backdrop-blur-sm shadow-sm">
      <SidebarTrigger className="-ml-1" />

      <div className="hidden sm:block sm:w-2/4 pl-1">
        <div className="overflow-hidden w-full">
          <BreadcrumbDemo />
        </div>
      </div>

      <div className="flex items-center sm:w-2/4 justify-end gap-2 pr-1">
        <div className="flex items-center gap-1 cursor-pointer border-2 rounded-2xl px-2 py-1 border-yellow-500 bg-yellow-600/20">
          <img src={CreditCoinSvg} alt="Credits" className="h-5 w-5" />
          <span className="text-sm font-medium">{RemainingTokens || 0}</span>
        </div>
        <div className="flex items-center gap-1 cursor-pointer border-2 rounded-2xl px-2 py-1 border-orange-500 bg-orange-600/20">
          <img src={FireSvg} alt="Streak" className="h-5 w-5" />
          <span className="text-sm font-medium">{subscription?.streak || 0}</span>
        </div>
        <UserMenu />
      </div>
    </header>
  );
};

export default AppTopbar;
